"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberOfStaff = exports.TitlesList = exports.CountriesListWithDialCode = void 0;
const checkout_1 = require("../checkout");
exports.CountriesListWithDialCode = checkout_1.COUNTRIES_LIST.map(({ key, text, countryCode }) => ({
    name: text,
    dialCode: `+${countryCode}`,
    code: key,
}));
exports.TitlesList = [
    { key: 1, text: 'Mr.', value: 'mr' },
    { key: 2, text: 'Mrs.', value: 'mrs' },
    { key: 3, text: 'Ms.', value: 'ms' },
];
exports.NumberOfStaff = [
    { key: 1, text: '1-10', value: '1-10' },
    { key: 2, text: '11-20', value: '11-20' },
    { key: 3, text: '21-30', value: '21-30' },
    { key: 4, text: '31-40', value: '31-40' },
    { key: 5, text: '40+', value: '40+' },
];
//# sourceMappingURL=index.js.map